var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59149 0.000135946H9.80729C10.7156 -0.00788204 11.5912 0.339049 12.2476 0.967038C13.6749 2.25624 14.6418 2.94689 15.2404 2.94689C15.7929 2.94689 12.754 5.52529 6.07781 10.6821C5.51894 11.1121 4.85084 11.377 4.14917 11.4467C3.4475 11.5165 2.74031 11.3884 2.10772 11.0769C1.47513 10.7654 0.942417 10.2829 0.569924 9.68421C0.197432 9.0855 4.90738e-05 8.39444 0.000136189 7.68931V3.63753C-0.00399152 3.16258 0.0857479 2.6915 0.2642 2.25133C0.442653 1.81116 0.706303 1.41058 1.04001 1.0726C1.37371 0.734613 1.7709 0.465881 2.20876 0.281836C2.64662 0.0977911 3.11653 0.00205863 3.59149 0.000135946Z",
    fill: "#26B99A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5572 2.90234H38.5844C39.5365 2.90356 40.4493 3.28233 41.1225 3.95557C41.7958 4.62882 42.1745 5.54158 42.1757 6.49369V14.5973C42.1745 15.5494 41.7958 16.4621 41.1225 17.1354C40.4493 17.8086 39.5365 18.1874 38.5844 18.1886H11.5572C10.6051 18.1874 9.69229 17.8086 9.01905 17.1354C8.3458 16.4621 7.96704 15.5494 7.96582 14.5973V6.49369C7.97484 5.544 8.35611 4.63576 9.02767 3.9642C9.69924 3.29263 10.6075 2.91136 11.5572 2.90234Z",
    fill: "#26B99A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08467 5.11122H39.0903C39.2052 5.11114 39.319 5.13372 39.4251 5.17765C39.5313 5.22159 39.6278 5.28603 39.709 5.36728C39.7903 5.44853 39.8547 5.545 39.8987 5.65117C39.9426 5.75734 39.9652 5.87114 39.9651 5.98604V19.4766C39.9652 19.5915 39.9426 19.7053 39.8987 19.8115C39.8547 19.9177 39.7903 20.0141 39.709 20.0954C39.6278 20.1766 39.5313 20.2411 39.4251 20.285C39.319 20.329 39.2052 20.3515 39.0903 20.3514H3.08467C2.96977 20.3515 2.85597 20.329 2.7498 20.285C2.64363 20.2411 2.54716 20.1766 2.46591 20.0954C2.38466 20.0141 2.32022 19.9177 2.27629 19.8115C2.23235 19.7053 2.20978 19.5915 2.20986 19.4766V5.98604C2.202 5.86913 2.21924 5.75189 2.26043 5.64219C2.30161 5.53249 2.36579 5.43287 2.44864 5.35001C2.5315 5.26716 2.63112 5.20298 2.74082 5.1618C2.85052 5.12061 2.96776 5.10337 3.08467 5.11122Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79568 6.53906H40.3797C40.8557 6.53965 41.3121 6.72902 41.6488 7.06565C41.9854 7.40228 42.1748 7.85867 42.1754 8.33474V28.4095C42.1741 29.3616 41.7954 30.2743 41.1221 30.9476C40.4489 31.6208 39.5361 31.9996 38.584 32.0008H3.59135C2.63924 31.9996 1.72647 31.6208 1.05323 30.9476C0.379983 30.2743 0.00121831 29.3616 0 28.4095V8.33474C0.00057755 7.85867 0.18995 7.40227 0.526579 7.06564C0.863208 6.72901 1.31961 6.53964 1.79568 6.53906Z",
    fill: "url(#paint0_linear_1583_12720)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1583_12720",
    x1: 21.0841,
    y1: 32.005,
    x2: 21.0841,
    y2: 6.54443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9875,
    stopColor: "#28DBB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d10e45f246c93c5b07ad9883f0ce79d7.svg";
export { ForwardRef as ReactComponent };